import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MacroProcess, _SubMacroProcess } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_BOOLEAN_ICON, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PrintObjectJson } from "../../../theme/Component/PrintObjectJson";
import { _InventoryCatalogByMarke, _MarketPlaceCategory, _MarketPlacePrice } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { EditorPriceList } from "../../../Factoty&Production/PriceList/EditorPriceList";
import { InputDate } from "../../../theme/Input/InputDate";
import { MarketPlaceCategoryEditor } from "./MarketPlaceCategoryEditor";
import { SelectProductLine } from "../../../theme/Component/SelectProductLine";
import { SelectProductTypeConstants } from "../SelectProductTypeConstants";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicButton } from "../../../theme/Component/BasicButton";

interface Props {
    idMarketPlace: number;
}

export const InventoryCatalogByMarke = ({ idMarketPlace }: Props) => {

    const markcatpric = useDataBean(_InventoryCatalogByMarke);
    const single = Singleton.getInstance();
    const paginador = usePaginator();
    const [MarketPlaceCategory, setMarketPlaceCategory] = useState<any>(null);
    const [IDLine, setIDLine] = useState<any>(null);
    const [regexStr, setregexStr] = useState<any>(null);
    const [ProdType, setProdType] = useState<any>(null);
    const [IDProduct, setIDProduct] = useState<any>(null);
    const [productCode, setProductCode] = useState<any>(null);
    const [reference, setReference] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idMarketPlace, paginador.page])

    const getLista = () => {

        markcatpric.instance.getInventoryCatalogByMarketPlace(idMarketPlace, MarketPlaceCategory, IDLine, regexStr, ProdType, productCode, reference, IDProduct, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        markcatpric.setBean({
            IDMarketPlace: idMarketPlace
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {

        // markcatpric.instance.deleteMarketPlacePriceList(markcatpric.bean.IDMarketPlacePriceList).then(
        //     (resp: any) => {
        //         getLista();
        //         setModalC({ ...modalC, "view": false });
        //     }
        // )
    }
    const editaItem = () => {

        // markcatpric.instance.addPriceListToMarketPlace(markcatpric.bean.IDPriceList, markcatpric.bean.FromDate, idMarketPlace).then(
        //     (resp: any) => {
        //         getLista();
        //         setModal({ ...modal, "view": false });
        //     }
        // ).catch(err => {
        //     toast.error(err);
        // })

    }

    const head = [
        { title: 'ID', property: 'IDProduct', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre del Producto', property: 'Description', visible: true },
        { title: 'Tipo de Producto', property: 'TypeName', visible: true },
        { title: 'Código', property: 'ProductCode', visible: true },
        { title: 'Tipo de Bien/Servicio', property: 'ArticleClassCodeName', visible: true },
        { title: 'Referencia', property: 'Reference', visible: true, mask: MASK_NUMBER },
        { title: 'SKU', property: 'StockKeepingUnit', visible: true },
        { title: 'Producto para Traslado a Consumo/Materia Prima', property: 'ProductConsumptionName', visible: true },
        { title: 'Grupo de Activos', property: 'ProductLineName', visible: true },
        { title: 'Estandard de Producción', property: 'Recipe', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Unidad de Media (Facturador UBL)', property: 'UBLMeasurementUnitName', visible: true },
        { title: 'Valor de Venta', property: 'SalesValue', visible: true, mask: MASK_MONEY },
        { title: 'Cantidades Negativas', property: 'AllowNegatives', visible: true },
        { title: 'Utilizar Costo de Producto', property: 'UseProductCost', visible: true },
        { title: 'Costo de Producto', property: 'ProductCost', visible: true },
        { title: 'Impuestos Incluidos', property: 'AddedTaxIncluded', visible: true, mask: MASK_BOOLEAN_ICON },
        { title: 'Cantidad Mínima en Stock', property: 'MinQuantityUnits', visible: true },
        { title: 'Cantidad Máxima en Stock', property: 'MaxQuantityUnits', visible: true },
        { title: 'Stock Promedio de Seguridad', property: 'SecurityStockUnits', visible: true },
        { title: 'Demanda Diaria Promedio', property: 'AverageDailyDemandUnits', visible: true },
        { title: 'Tiempo de Entrega Promedio en Días', property: 'AverageDeliverTimeInDays', visible: true },
        { title: 'Hoja de Vida/Especificaciones del Producto', property: 'URL', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-6">
                <MarketPlaceCategoryEditor idMarketPlace={idMarketPlace} idSelector={MarketPlaceCategory} onChange={(e) => { setMarketPlaceCategory(e) }} />
            </div>
            <div className="col-md-6">
                <SelectProductLine idSelector={IDLine} onChange={(e) => { setIDLine(e) }} label="Grupo de Activos" />
            </div>
            <div className="col-md-6">
                <label>Búsqueda por Texto</label>
                <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
            </div>
            <div className="col-md-6">
                <SelectProductTypeConstants idSelector={ProdType} onChange={(e) => { setProdType(e) }} />
            </div>
            <div className="col-md-6">
                <label>ID Producto</label>
                <input type="text" className="form-control" value={IDProduct} onChange={(e) => { setIDProduct(e.target.value) }} />
            </div>
            <div className="col-md-6">
                <label>Código de Producto</label>
                <input type="text" className="form-control" value={productCode} onChange={(e) => { setProductCode(e.target.value) }} />
            </div>
            <div className="col-md-6">
                <label>Referencia de Producto</label>
                <input type="text" className="form-control" value={reference} onChange={(e) => { setReference(e.target.value) }} />
            </div>
            <div className="col-md-6 mt-4 p-2">
                <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={markcatpric.setBean} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <InputDate name="FromDate" label="Fecha desde" value={markcatpric.bean.FromDate} setDate={(e: any) => { markcatpric.setBean({ ...markcatpric.bean, "FromDate": e }) }} />
                        </div>
                        <div className="col-md-12">
                            <EditorPriceList onChange={(e) => { markcatpric.setBean({ ...markcatpric.bean, IDPriceList: e.IDPriceList }) }} label="Listado de precios" />
                        </div>

                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}